import { useMemo } from 'react';
import { telegram } from '../utils/telegram';

export interface HapticActions {
  notifySuccess: () => void;
  notifyError: () => void;
  notifyWarning: () => void;
  impactLight: () => void;
  impactMedium: () => void;
}

/**
 * Returns stable haptic feedback actions.
 */
export function useHaptic(): HapticActions {
  return useMemo(
    () => ({
      notifySuccess: () => telegram.hapticFeedback.notification('success'),
      notifyError: () => telegram.hapticFeedback.notification('error'),
      notifyWarning: () => telegram.hapticFeedback.notification('warning'),
      impactLight: () => telegram.hapticFeedback.impact('light'),
      impactMedium: () => telegram.hapticFeedback.impact('medium'),
    }),
    [],
  );
}
